[
 {
  "id": "radio",
  "x": 117,
  "y": 502,
  "w": 94,
  "h": 94
 },
 {
  "id": "toggle",
  "x": 660,
  "y": 1296,
  "w": 178,
  "h": 106
 }
]